export default __webpack_public_path__ + "static/media/212.bfa07ecb.png";